export default __webpack_public_path__ + "static/media/service-ticket-manager.36bb55d6.png";